import { css } from '@emotion/react';
import { ReactNode } from 'react';

import { useGrowthbook } from '../providers/GrowthbookProvider';

import { SasModal } from './SasModal';

const styles = {
  buttonContainer: css`
    display: flex;
    justify-content: flex-end;
  `,
};

export const FlowEnabled = ({ children }: { children: ReactNode }) => {
  const { inMaintenanceMode } = useGrowthbook();

  const handleOk = () => {
    const currentLocation = window.location;
    const localeMatch = currentLocation.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//);

    window.location.href = `${currentLocation.origin}/${localeMatch ? `${localeMatch[1]}/` : ''}`;
  };

  if (inMaintenanceMode) {
    return (
      <SasModal open={true} showCloseButton={false}>
        <h3>{`Ah snap, something's gone astray`}</h3>
        <p>{`This page is currently in maintenance mode. Please try again later.`}</p>
        <div css={styles.buttonContainer}>
          <button onClick={handleOk}>{'Ok'}</button>
        </div>
      </SasModal>
    );
  }

  return <>{children}</>;
};
